import { Skeleton } from "@mui/material"
import React, { ReactNode } from "react"

interface IProps {
    children: ReactNode,
    showTitle?: boolean,
    title?: string,
    description?: string,
    loading?: boolean,
    noWrap?: boolean,
    addButton?: () => JSX.Element,
}

const SectionBoxContainer: React.FC<IProps> = ({ children, ...props }) => {

    const { showTitle, title, description, loading, noWrap, addButton } = props

    if (noWrap){
        return <>{children}</>
    }

    return(
        <div className="section-box-admin-panel">
                
            {showTitle && (
                <div className="head-box-of-section-box-admin-panel">
                    <div className="content-of-head-box-of-section-box-admin-panel">
                        {title && <h3>{loading ? <Skeleton variant="text" width={100} height={35} /> : title} {addButton && addButton()}</h3>}
                        {description && <p>{loading ? <Skeleton variant="text" width={150}  /> : description}</p>}
                    </div>
                </div>
            )}

            <div className="content-of-section-box-admin-panel">
                {children}
            </div>
        </div>
    )
}

export default SectionBoxContainer